// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"Checkbox_checkbox___dHmp","checkboxInput":"Checkbox_checkboxInput__fvx08","checkboxIcon":"Checkbox_checkboxIcon__YuIR8"};